
import React from 'react';

import ReactDOM from 'react-dom';

import { Button } from "@jd/find-react";
import { Cascader } from 'element-react';

 

import KeeVue from '../base/KeeVue.js'

import $ from 'jquery';
import FeasComponents from '../render/FeasComponents.js'




export default class FsLayout extends KeeVue {
	constructor(props) {
		super(props);

		this.state = {
			isShow: false,
			randId: this.getRandString(),
			isShowMenu: false,
			toHide: false,
			isScrolling: false,
			selectItem: null,
			menuStyle: {
				left: 5,
				top: 0,
				width: 0,
				height: 0,
			},
			listData: null,
			layoutHeight: "100px",
			showPanels: "",
		}

	}

	componentWillMount() {
		var that = this;
		if (this.props.parentLayout === null) {
			this.onEvent("keeResize", this.resizeHeight);
			that.resizeHeight();
			// setTimeout(function () {
			// 	that.resizeHeight();
			// }, 100);
		}
		// if (!this.isNotBlank(this.props.component.cp.bottomHeight)) {
		// 	this.props.component.cp.bottomHeight = "0px";
		// }
		// this.props.component.style.position = "static";

		this.registComponent();
	}

	showConfig = () => { }
	onCommand = (cmdName, item, po, thisForm, parentForm) => {
		this.$emit("command", cmdName, item, po, thisForm, parentForm);
	}
	onChanged = (ret) => {
		this.$emit("changed", ret);
	}
	resizeHeight = () => {
		var that = this;
		var newHeight = 0;
		if ($("#" + that.state.randId).offset() !== null) {
			var top = $("#" + that.state.randId).offset().top;
			if (top !== 0) {
				console.log("表格top:" + top);
				newHeight = (window.innerHeight - top - 8);
				console.log("layoutHeight:" + newHeight);
				var thisDiv = $("#" + that.state.randId);
				var parent = thisDiv.parent();
				while (true) {
					var num = parseInt(parent.css('margin-bottom'));
					if (num !== null && num > 0) {
						newHeight = newHeight - num;
					}
					console.log("parent.css('margin-bottom')====" + num);
					if (parent.height() < $(parent)[0].scrollHeight) {
						newHeight = (newHeight - ($(parent)[0].scrollHeight - parent.height()));
						console.log("layoutHeight:" + newHeight);
						break;
					}
					parent = parent.parent();
					if (parent.attr("id") === "feasApp") {
						break;
					}
				}
			}
		}
		if (newHeight < 260) {
			newHeight = 260;
		}
		this.layoutHeight = newHeight + "px";
	}

	render() {
		
		
		return (

			<div id={this.state.randId} className={`kee-layout ${this.props.parentLayout !== null ? 'kee-layout-child' : ''}`}
				style={this.props.component.style} >

				{
					this.props.component.child.map((item, index) => {

						let style ;
						
						if (item.cp.position === 'left' && this.props.component.cp.isShowLeft === true) {
							style = {
							}
							style.top = this.props.component.cp.topHeight;
							style.width = this.props.component.cp.leftWidth;
							style.bottom = this.props.component.cp.bottomHeight;
							 
						}
						if (item.cp.position === 'top' && this.props.component.cp.isShowTop === true) {
							style = {
							}
							style.height = this.props.component.cp.topHeight;

						}
						if (item.cp.position === 'right' && this.props.component.cp.isShowRight === true) {
							style = {
							}
							style.top = this.props.component.cp.topHeight;
							style.width = this.props.component.cp.rightWidth;
							style.bottom = this.props.component.cp.bottomHeight;
						}
						if (item.cp.position === 'center') {
							style = {
							}
							style.top = this.props.component.cp.topHeight;
							style.left = this.props.component.cp.leftWidth;
							style.right = this.props.component.cp.rightWidth;
							style.bottom = this.props.component.cp.bottomHeight;
						}
						if (item.cp.position === 'bottom' && this.props.component.cp.isShowBottom === true) {
							style = {
							}
							style.height = this.props.component.cp.bottomHeight;
						}


						if (style != null) {
							return <div key={item.id} id={item.id}
								boxid={item.id}
								className={`kee-layout-panel kee-layout-panel-${item.cp.position}`}
								style={style} >
								{
									item.child && <FeasComponents components={item.child}
										po={this.props.po}
										thisForm={this.props.thisForm}
										parentForm={this.props.parentForm}
										name={this.props.name}
										query={this.props.query}
										editable={this.props.editable}
										debug={this.props.debug}
										oncommand={this.onCommand}
										onChanged={this.onChanged}>
									</FeasComponents>
								}
							</div>
						}
						else {
							return "";
						}
					})
				}
			</div >
		);
	}
}
